import { TimerCheckOutlineIcon } from './TimerCheckOutlineIcon';

/**
 * author: Colton Wiscombe
 * id AA368E7E-E808-48E4-9DFF-826156E12D8B
 * name timer-check-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-check-outline.svg
 * tags
 * - Date / Time 
 */
export const StopwatchTickOutlineIcon = TimerCheckOutlineIcon;
export default StopwatchTickOutlineIcon